/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-09-11 09:41:10
 */

import { usePayment } from '../../../app/hooks'

export const matchSourceDetail = () => {
  let pathname = window.location.pathname
  if (pathname === '/watermark/list') {
    return 'watermarkListChooseMember'
  } else if (pathname === '/watermark/editor') {
    return 'watermarkEditorChooseMember'
  } else {
    return pathname
  }
}

export const useOnPay = () => {
  const payment = usePayment()
  return () => payment.open(matchSourceDetail())
}
